import { FC, ReactNode } from 'react';
import { usePlatformConfig } from '@belong/device-bridge';
import { ID, IFooterMenu, IHeaderMenu, INavLinkProps, IPageAlert } from '@belong/types';
import Breadcrumbs from '@belong/ui-components/components/navigation/Breadcrumbs';
import GlobalFooterContainer from '../containers/GlobalFooterContainer';
import GlobalHeaderContainer from '../containers/GlobalHeaderContainer';
import { Main } from './styles';

interface IProps {
  headerMenuContent: IHeaderMenu;
  footerMenuContent: IFooterMenu;
  pageAlert?: IPageAlert;
  children?: ReactNode;
  shouldHaveLiveChat: boolean;
  breadcrumbs?: INavLinkProps[];
  isNbnOrderCartReady?: boolean;
}

const LayoutShell: FC<IProps> = ({
  children,
  headerMenuContent,
  footerMenuContent,
  pageAlert,
  shouldHaveLiveChat,
  breadcrumbs,
  isNbnOrderCartReady
}: IProps) => {
  const { isNativeApp } = usePlatformConfig();

  const main = <Main id={ID.CONTENT}>{children}</Main>;

  if (isNativeApp) {
    return main;
  }

  return (
    <GlobalHeaderContainer
      headerMenuContent={headerMenuContent}
      pageAlert={pageAlert}
      showBackToTopTrigger={!shouldHaveLiveChat}
      isNbnOrderCartReady={isNbnOrderCartReady}
    >
      {breadcrumbs?.length && <Breadcrumbs links={breadcrumbs} />}
      {main}
      <GlobalFooterContainer {...footerMenuContent} />
    </GlobalHeaderContainer>
  );
};

LayoutShell.displayName = 'LayoutShell';

export default LayoutShell;
